import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { SITE_URL } from '@/lib/seo';

export default function TermsPage() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />

      <div className="pt-16 bg-background-50 border-b border-background-200">
        <div className="w-full px-4 md:px-8 lg:px-12 py-3">
          <nav aria-label="breadcrumb">
            <ol className="flex items-center gap-2 text-sm text-foreground-500">
              <li><a href="/" className="hover:text-primary-600 transition-colors">Home</a></li>
              <li><i className="ri-arrow-right-s-line text-xs" /></li>
              <li><span className="text-foreground-700">Terms & Conditions</span></li>
            </ol>
          </nav>
        </div>
      </div>

      <main className="flex-1 w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 max-w-4xl mx-auto">
        <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6">Terms & Conditions</h1>
        <div className="text-foreground-700 leading-relaxed space-y-4">
          <p>
            By accessing and using this website, you accept and agree to be bound by these Terms & Conditions.
            If you do not agree to these terms, please do not use this website.
          </p>
          <h2 className="text-xl font-semibold text-foreground-900 mt-8 mb-2">Use of Information</h2>
          <p>
            All information provided on this website is for informational and educational purposes only.
            We make no representations or warranties about the accuracy, completeness, or reliability of any information.
          </p>
          <h2 className="text-xl font-semibold text-foreground-900 mt-8 mb-2">External Links</h2>
          <p>
            This website contains links to external websites. We are not responsible for the content, products,
            services, or practices of any third-party websites. Use external links at your own discretion.
          </p>
          <h2 className="text-xl font-semibold text-foreground-900 mt-8 mb-2">No Affiliation</h2>
          <p>
            This website is an independent informational resource and is not affiliated with AllChinaBuy or any
            buying agent platform unless explicitly stated. All trademarks and brand names belong to their respective owners.
          </p>
          <h2 className="text-xl font-semibold text-foreground-900 mt-8 mb-2">Limitation of Liability</h2>
          <p>
            We shall not be liable for any damages arising from the use of this website or reliance on any information
            provided herein. Always conduct your own research and make independent decisions.
          </p>
          <p className="text-sm text-foreground-500 mt-8">
            Last updated: August 26, 2026
          </p>
        </div>
      </main>

      <Footer />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Terms & Conditions",
          "url": `${SITE_URL}/terms/`,
          "description": "Terms and conditions for using AllChinaBuy Spreadsheet, an independent informational resource for buying guidance."
        })}
      </script>
    </div>
  );
}